<template>
  <div>
    <v-data-table
      :value="value"
      :headers="headers"
      :items="items"
      :single-select="singleSelect"
      :item-key="itemKey"
      :show-select="showSelect"
      class="elevation-1"
      hide-default-footer
      hide-default-divider
      :loading="loading"
      loading-text="Cargando información..."
      :style="{ borderRadius: borderRadius }"
      :height="height"
      :fixed-header="fixedHeader"
      @input="(value) => $emit('input', value)"
    >
      <template v-slot:top v-if="title">
        <GenericTitle
          class="text-center pt-7 pb-3"
          :title="title"
          font-size="16px"
          :font-weight="600"
        />
      </template>
      <template v-slot:[`item.registrationDate`]="{ item }">
        <div class="status-item__container">
          <ElapsedTimer :fechaCreacion="item.registrationDate" />
        </div>
      </template>
      <template v-if="actions.length > 0" v-slot:[`item.actions`]="{ item }">
        <div v-if="actions.includes('call')">
          <v-btn
            small
            dark
            :color="getColorPriority(item)"
            rounded
            @click="() => $emit('callAction', item)"
            ><v-icon left>{{ getCallButtonIcon(item) }}</v-icon>
            {{ item.statusName }}</v-btn
          >
        </div>
      </template>
    </v-data-table>
    <template>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </template>
  </div>
</template>

<script>
import GenericTitle from '../../common/titles/GenericTitle';
import ElapsedTimer from '../../common/elapsedTimer/ElapsedTimer';
import { ticketStatuses, priorityTypes } from '@/domain/global.enum';

export default {
  name: 'DataTableTickets',
  props: {
    title: { type: String, default: null },
    value: { type: Array, default: () => [] },
    headers: { type: Array, default: () => [] },
    items: { type: Array, default: () => [] },
    actions: { type: Array, default: () => [] },
    borderRadius: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    overlay: { type: Boolean, default: false },
    itemKey: { type: String, default: '' },
    showSelect: { type: Boolean, default: false },
    height: { type: Number, default: 250 },
    fixedHeader: { type: Boolean, default: false },
  },
  components: {
    GenericTitle,
    ElapsedTimer,
  },
  data: () => ({
    singleSelect: true,
  }),
  methods: {
    getColorPriority({ priorityType }) {
      switch (priorityType) {
        case priorityTypes.CRITICAL_CUSTOMER:
          return '#FA6A59';
        default:
          return 'primary';
      }
    },
    getCallButtonIcon({ statusCode }) {
      switch (statusCode) {
        case ticketStatuses.PENDING:
          return 'mdi-phone';
        case ticketStatuses.ATTENDING:
          return 'mdi-phone-paused';
        case ticketStatuses.PAUSE:
          return 'mdi-phone-paused';
        case ticketStatuses.FINALIZED:
          return 'mdi-phone-paused';
        case ticketStatuses.REJECTED:
          return 'mdi-phone-paused';
        case ticketStatuses.CALLING:
          return 'mdi-phone-paused';
        default:
          return 'mdi-phone';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: none;
}
.status-item {
  &__container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__circle {
    border-radius: 50%;
    border: 5px solid;
  }
}
</style>
